
class CapEditStudentContact {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'edit_student_contact'
}

function create(config) {
  return new CapEditStudentContact(config)
}

export default {
  key,
  create,
}
